import { faFolder } from '@fortawesome/pro-light-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import shortid from 'shortid';

export const BackToAttestationFormIcon = ({ size = '2x' }) => {
  const theme = useTheme();
  return (
    <span className={`fa-layers fa-fw fa-${size}`}>
      <FontAwesomeIcon
        color={theme.palette.primary.main}
        icon={faFolder}
        key={shortid.generate()}
      />
      <FontAwesomeIcon
        color={theme.palette.primary.main}
        icon={faArrowLeft}
        key={shortid.generate()}
        transform="shrink-8 down-0.5"
      />
    </span>
  );
};
